import { render, staticRenderFns } from "./CommentView.vue?vue&type=template&id=48d33018"
import script from "./CommentView.vue?vue&type=script&lang=js"
export * from "./CommentView.vue?vue&type=script&lang=js"
import style0 from "./CommentView.vue?vue&type=style&index=0&id=48d33018&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports